package flagpack.icons.large

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Norfolk Island Flag (32x24dp)
 *
 * - ISO Alpha-2: NF
 * - ISO Alpha-3: NFK
 * - ISO Numeric: 574
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Large.NorfolkIsland: ImageVector by lazy {
    ImageVector.Builder(
        name = "Norfolk Island:NF:NFK:574:Large",
        defaultWidth = 32.dp,
        defaultHeight = 24.dp,
        viewportWidth = 32f,
        viewportHeight = 24f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(32f)
                verticalLineToRelative(24f)
                horizontalLineToRelative(-32f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF409100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(22f, 0f)
                horizontalLineTo(32f)
                verticalLineTo(24f)
                horizontalLineTo(22f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF409100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(10f)
                verticalLineTo(24f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(10f, 0f)
                horizontalLineTo(22f)
                verticalLineTo(24f)
                horizontalLineTo(10f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF409100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(12.695f, 18.771f)
                curveTo(11.14f, 19.024f, 10.649f, 18.264f, 10.649f, 18.264f)
                lineTo(10.845f, 18.103f)
                curveTo(10.977f, 17.995f, 11.42f, 18.032f, 11.85f, 18.068f)
                curveTo(12.061f, 18.086f, 12.268f, 18.103f, 12.435f, 18.103f)
                curveTo(12.677f, 18.103f, 12.957f, 18.067f, 13.248f, 18.029f)
                curveTo(13.564f, 17.987f, 13.895f, 17.944f, 14.207f, 17.944f)
                curveTo(14.806f, 17.944f, 12.435f, 17.16f, 11.928f, 17.641f)
                curveTo(11.421f, 18.121f, 10f, 17.418f, 10f, 17.017f)
                curveTo(10f, 16.744f, 10.523f, 16.843f, 11f, 16.934f)
                curveTo(11.223f, 16.977f, 11.435f, 17.017f, 11.58f, 17.017f)
                curveTo(12.035f, 17.017f, 11.124f, 16.128f, 10.649f, 16.128f)
                curveTo(10.175f, 16.128f, 11.124f, 15.921f, 11.58f, 15.921f)
                curveTo(11.839f, 15.921f, 12.08f, 15.988f, 12.288f, 16.046f)
                curveTo(12.445f, 16.09f, 12.583f, 16.128f, 12.695f, 16.128f)
                curveTo(12.956f, 16.128f, 11.387f, 15.453f, 11.124f, 15.453f)
                horizontalLineTo(12.435f)
                curveTo(12.885f, 15.453f, 12.994f, 15.517f, 13.097f, 15.577f)
                curveTo(13.191f, 15.631f, 13.279f, 15.682f, 13.608f, 15.682f)
                curveTo(14.301f, 15.682f, 13.922f, 15.303f, 13.922f, 15.303f)
                curveTo(13.922f, 15.303f, 11.58f, 15.06f, 11.124f, 14.724f)
                curveTo(10.816f, 14.497f, 11.643f, 14.577f, 12.425f, 14.653f)
                lineTo(12.425f, 14.653f)
                curveTo(12.799f, 14.689f, 13.163f, 14.724f, 13.387f, 14.724f)
                curveTo(14.078f, 14.724f, 11.928f, 14.23f, 11.58f, 14.23f)
                horizontalLineTo(13.165f)
                curveTo(13.512f, 14.23f, 13.892f, 14.342f, 14.292f, 14.459f)
                lineTo(14.292f, 14.459f)
                curveTo(14.733f, 14.588f, 15.197f, 14.724f, 15.663f, 14.724f)
                curveTo(16.155f, 14.724f, 15.195f, 14.431f, 14.14f, 14.109f)
                lineTo(14.14f, 14.109f)
                curveTo(13.288f, 13.849f, 12.374f, 13.569f, 12.114f, 13.411f)
                curveTo(11.846f, 13.247f, 12.05f, 13.31f, 12.422f, 13.426f)
                curveTo(12.855f, 13.561f, 13.515f, 13.766f, 13.922f, 13.766f)
                curveTo(14.679f, 13.766f, 12.914f, 13.023f, 12.435f, 13.023f)
                curveTo(11.955f, 13.023f, 11.496f, 12.807f, 11.928f, 12.607f)
                curveTo(12.193f, 12.485f, 12.884f, 12.67f, 13.486f, 12.83f)
                curveTo(13.865f, 12.931f, 14.208f, 13.023f, 14.388f, 13.023f)
                curveTo(14.606f, 13.023f, 14.767f, 13.108f, 14.939f, 13.198f)
                curveTo(15.134f, 13.301f, 15.342f, 13.411f, 15.663f, 13.411f)
                curveTo(16.266f, 13.411f, 14.388f, 12.607f, 13.608f, 12.607f)
                curveTo(12.828f, 12.607f, 12.695f, 12.229f, 13.165f, 12.229f)
                curveTo(13.634f, 12.229f, 12.114f, 11.585f, 12.114f, 11.585f)
                curveTo(12.114f, 11.585f, 11.894f, 11.127f, 12.435f, 11.127f)
                horizontalLineTo(13.165f)
                curveTo(13.415f, 11.127f, 12.914f, 10.334f, 12.435f, 10.334f)
                curveTo(11.955f, 10.334f, 12.373f, 10.095f, 13.165f, 10.095f)
                curveTo(13.646f, 10.095f, 13.927f, 10.261f, 14.266f, 10.461f)
                curveTo(14.484f, 10.59f, 14.726f, 10.732f, 15.061f, 10.854f)
                curveTo(15.914f, 11.163f, 15.27f, 10.334f, 15.061f, 10.334f)
                curveTo(14.851f, 10.334f, 12.695f, 9.659f, 12.695f, 9.659f)
                curveTo(12.695f, 9.659f, 12.914f, 9.41f, 12.695f, 9.071f)
                curveTo(12.53f, 8.815f, 13.218f, 8.945f, 13.637f, 9.025f)
                curveTo(13.773f, 9.051f, 13.881f, 9.071f, 13.922f, 9.071f)
                curveTo(14.021f, 9.071f, 14.305f, 9.142f, 14.655f, 9.229f)
                lineTo(14.655f, 9.229f)
                curveTo(14.891f, 9.287f, 15.157f, 9.353f, 15.415f, 9.41f)
                curveTo(16.055f, 9.55f, 13.239f, 8.376f, 12.914f, 8.376f)
                curveTo(12.59f, 8.376f, 13.608f, 8.183f, 14.207f, 8.183f)
                curveTo(14.502f, 8.183f, 14.644f, 8.229f, 14.788f, 8.277f)
                curveTo(14.937f, 8.326f, 15.089f, 8.376f, 15.415f, 8.376f)
                curveTo(16.055f, 8.376f, 14.207f, 7.689f, 13.608f, 7.689f)
                curveTo(13.009f, 7.689f, 13.363f, 7.098f, 13.608f, 7.098f)
                curveTo(13.703f, 7.098f, 13.944f, 7.13f, 14.239f, 7.169f)
                lineTo(14.239f, 7.169f)
                lineTo(14.239f, 7.169f)
                horizontalLineTo(14.239f)
                lineTo(14.239f, 7.169f)
                lineTo(14.239f, 7.169f)
                lineTo(14.239f, 7.169f)
                curveTo(14.701f, 7.229f, 15.295f, 7.307f, 15.663f, 7.307f)
                curveTo(15.943f, 7.307f, 15.687f, 7.229f, 15.315f, 7.115f)
                lineTo(15.315f, 7.115f)
                lineTo(15.315f, 7.115f)
                curveTo(14.886f, 6.983f, 14.304f, 6.805f, 14.207f, 6.644f)
                curveTo(14.1f, 6.467f, 14.317f, 6.499f, 14.696f, 6.555f)
                lineTo(14.696f, 6.555f)
                curveTo(14.765f, 6.565f, 14.839f, 6.576f, 14.917f, 6.587f)
                curveTo(15.175f, 6.722f, 15.391f, 6.809f, 15.422f, 6.706f)
                curveTo(15.431f, 6.677f, 15.452f, 6.655f, 15.477f, 6.64f)
                curveTo(15.538f, 6.643f, 15.6f, 6.644f, 15.663f, 6.644f)
                curveTo(16.02f, 6.644f, 15.855f, 6.59f, 15.511f, 6.525f)
                lineTo(15.481f, 6.515f)
                curveTo(14.959f, 6.356f, 13.83f, 6.015f, 14.253f, 6.225f)
                curveTo(14.335f, 6.266f, 14.428f, 6.317f, 14.525f, 6.371f)
                curveTo(14.24f, 6.333f, 14.001f, 6.307f, 13.922f, 6.307f)
                curveTo(13.636f, 6.307f, 13.35f, 6.087f, 13.922f, 6.087f)
                horizontalLineTo(15.061f)
                curveTo(14.706f, 6.087f, 14.207f, 6.087f, 14.207f, 5.808f)
                curveTo(14.207f, 5.619f, 14.602f, 5.687f, 14.967f, 5.75f)
                curveTo(15.138f, 5.78f, 15.302f, 5.808f, 15.415f, 5.808f)
                curveTo(15.769f, 5.808f, 15.857f, 5.808f, 15.663f, 5.643f)
                curveTo(15.479f, 5.486f, 14.843f, 5.486f, 14.448f, 5.487f)
                lineTo(14.388f, 5.487f)
                curveTo(14.001f, 5.487f, 15.208f, 5.285f, 15.663f, 5.285f)
                curveTo(15.74f, 5.285f, 15.773f, 5.285f, 15.774f, 5.283f)
                curveTo(15.774f, 5.282f, 15.752f, 5.28f, 15.715f, 5.277f)
                curveTo(15.517f, 5.257f, 14.858f, 5.193f, 14.388f, 4.981f)
                curveTo(13.967f, 4.79f, 14.336f, 4.838f, 14.818f, 4.9f)
                curveTo(15.107f, 4.938f, 15.437f, 4.981f, 15.663f, 4.981f)
                curveTo(16.266f, 4.981f, 15.415f, 4.575f, 14.774f, 4.575f)
                curveTo(14.26f, 4.575f, 14.505f, 4.435f, 14.823f, 4.253f)
                lineTo(14.823f, 4.253f)
                curveTo(14.901f, 4.208f, 14.984f, 4.161f, 15.061f, 4.112f)
                curveTo(15.292f, 3.967f, 15.461f, 4.215f, 15.56f, 4.361f)
                curveTo(15.628f, 4.46f, 15.663f, 4.512f, 15.663f, 4.357f)
                curveTo(15.663f, 4.206f, 15.624f, 4.11f, 15.592f, 4.06f)
                curveTo(15.609f, 4.074f, 15.632f, 4.092f, 15.663f, 4.112f)
                curveTo(15.911f, 4.278f, 15.663f, 3.678f, 15.663f, 3.678f)
                curveTo(15.663f, 3.678f, 15.415f, 3.512f, 15.663f, 3.512f)
                curveTo(15.911f, 3.512f, 15.583f, 3.227f, 15.415f, 3.227f)
                curveTo(15.246f, 3.227f, 15.857f, 2.954f, 15.857f, 2.954f)
                lineTo(15.992f, 1.8f)
                curveTo(15.992f, 1.8f, 16.325f, 3.058f, 16.325f, 3.227f)
                verticalLineTo(4.112f)
                curveTo(16.325f, 4.323f, 16.176f, 4.47f, 16.076f, 4.568f)
                curveTo(15.951f, 4.692f, 15.903f, 4.739f, 16.325f, 4.739f)
                curveTo(17.082f, 4.739f, 17.049f, 4.981f, 16.589f, 4.981f)
                curveTo(16.128f, 4.981f, 16.721f, 5.285f, 17.548f, 5.285f)
                curveTo(18.376f, 5.285f, 16.854f, 5.643f, 16.325f, 5.643f)
                curveTo(15.795f, 5.643f, 16.854f, 5.808f, 17.548f, 5.808f)
                curveTo(18.017f, 5.808f, 17.536f, 5.97f, 17.093f, 6.12f)
                curveTo(16.88f, 6.192f, 16.675f, 6.26f, 16.589f, 6.307f)
                curveTo(16.451f, 6.381f, 16.79f, 6.379f, 17.149f, 6.359f)
                curveTo(16.961f, 6.415f, 16.773f, 6.472f, 16.631f, 6.515f)
                curveTo(16.458f, 6.568f, 16.4f, 6.586f, 16.401f, 6.593f)
                curveTo(16.402f, 6.597f, 16.418f, 6.598f, 16.442f, 6.599f)
                curveTo(16.515f, 6.603f, 16.66f, 6.611f, 16.689f, 6.706f)
                curveTo(16.733f, 6.849f, 17.127f, 6.628f, 17.5f, 6.419f)
                curveTo(17.56f, 6.386f, 17.619f, 6.353f, 17.676f, 6.321f)
                curveTo(17.774f, 6.313f, 17.837f, 6.307f, 17.837f, 6.307f)
                curveTo(17.837f, 6.307f, 18.18f, 6.703f, 18.18f, 6.944f)
                curveTo(18.18f, 7.085f, 17.729f, 7.127f, 17.248f, 7.171f)
                lineTo(17.2f, 7.176f)
                curveTo(17.224f, 7.144f, 17.122f, 7.16f, 16.971f, 7.198f)
                curveTo(16.722f, 7.223f, 16.486f, 7.255f, 16.325f, 7.307f)
                curveTo(16.17f, 7.358f, 16.196f, 7.379f, 16.322f, 7.383f)
                lineTo(16.288f, 7.393f)
                curveTo(16.17f, 7.43f, 16.129f, 7.442f, 16.13f, 7.449f)
                curveTo(16.13f, 7.453f, 16.142f, 7.455f, 16.16f, 7.459f)
                horizontalLineTo(16.16f)
                curveTo(16.212f, 7.469f, 16.317f, 7.489f, 16.346f, 7.584f)
                curveTo(16.39f, 7.727f, 16.653f, 7.546f, 16.902f, 7.375f)
                lineTo(16.926f, 7.359f)
                curveTo(17.004f, 7.354f, 17.084f, 7.349f, 17.163f, 7.343f)
                lineTo(17.163f, 7.343f)
                lineTo(17.163f, 7.343f)
                curveTo(17.434f, 7.325f, 17.694f, 7.307f, 17.837f, 7.307f)
                curveTo(18.284f, 7.307f, 17.391f, 7.523f, 17.049f, 7.523f)
                curveTo(16.904f, 7.523f, 17.087f, 7.556f, 17.366f, 7.606f)
                curveTo(17.743f, 7.674f, 18.296f, 7.773f, 18.452f, 7.865f)
                curveTo(18.638f, 7.976f, 18.091f, 7.934f, 17.603f, 7.898f)
                lineTo(17.603f, 7.898f)
                curveTo(17.381f, 7.881f, 17.171f, 7.865f, 17.049f, 7.865f)
                curveTo(16.661f, 7.865f, 16.589f, 8.183f, 16.854f, 8.183f)
                horizontalLineTo(17.837f)
                curveTo(18.209f, 8.183f, 18.596f, 8.752f, 18.452f, 8.752f)
                curveTo(18.408f, 8.752f, 18.315f, 8.781f, 18.184f, 8.822f)
                curveTo(17.883f, 8.916f, 17.387f, 9.071f, 16.854f, 9.071f)
                curveTo(16.09f, 9.071f, 17.837f, 9.072f, 18.18f, 9.071f)
                curveTo(18.523f, 9.07f, 19.501f, 9.072f, 19.501f, 9.41f)
                curveTo(19.501f, 9.62f, 19.316f, 9.666f, 19.073f, 9.727f)
                curveTo(18.926f, 9.764f, 18.757f, 9.806f, 18.596f, 9.893f)
                curveTo(18.17f, 10.124f, 19.872f, 10.334f, 19.872f, 10.334f)
                curveTo(19.872f, 10.334f, 19.198f, 10.544f, 18.87f, 10.544f)
                curveTo(18.542f, 10.544f, 19.023f, 10.854f, 19.872f, 10.854f)
                curveTo(20.529f, 10.854f, 20.336f, 11.211f, 20.215f, 11.434f)
                lineTo(20.215f, 11.434f)
                curveTo(20.18f, 11.5f, 20.15f, 11.554f, 20.15f, 11.585f)
                curveTo(20.15f, 11.643f, 20.026f, 11.694f, 19.846f, 11.768f)
                curveTo(19.615f, 11.862f, 19.292f, 11.994f, 19.023f, 12.229f)
                curveTo(18.713f, 12.499f, 19.089f, 12.42f, 19.514f, 12.33f)
                lineTo(19.514f, 12.33f)
                curveTo(19.746f, 12.281f, 19.993f, 12.229f, 20.15f, 12.229f)
                curveTo(20.597f, 12.229f, 20.787f, 12.248f, 20.641f, 12.464f)
                curveTo(20.496f, 12.681f, 19.198f, 13.023f, 18.87f, 13.023f)
                horizontalLineTo(20.641f)
                curveTo(21.132f, 13.023f, 20.504f, 13.411f, 19.872f, 13.411f)
                curveTo(19.448f, 13.411f, 19.211f, 13.57f, 19.055f, 13.675f)
                curveTo(18.978f, 13.727f, 18.92f, 13.766f, 18.87f, 13.766f)
                horizontalLineTo(20.15f)
                curveTo(20.215f, 13.766f, 20.287f, 13.661f, 20.353f, 13.566f)
                curveTo(20.411f, 13.482f, 20.464f, 13.405f, 20.504f, 13.411f)
                curveTo(21.083f, 13.502f, 20.823f, 14.23f, 20.504f, 14.23f)
                curveTo(20.137f, 14.23f, 19.023f, 14.476f, 19.198f, 14.724f)
                curveTo(19.283f, 14.844f, 19.416f, 14.79f, 19.631f, 14.702f)
                curveTo(19.86f, 14.608f, 20.183f, 14.476f, 20.641f, 14.476f)
                curveTo(21.53f, 14.476f, 20.727f, 14.724f, 20.504f, 14.724f)
                curveTo(20.281f, 14.724f, 19.337f, 14.904f, 19.023f, 15.06f)
                curveTo(18.813f, 15.164f, 19.543f, 15.129f, 20.27f, 15.094f)
                curveTo(20.631f, 15.077f, 20.992f, 15.06f, 21.235f, 15.06f)
                curveTo(21.967f, 15.06f, 19.501f, 15.682f, 18.596f, 15.682f)
                curveTo(17.691f, 15.682f, 19.198f, 15.921f, 19.501f, 15.921f)
                curveTo(19.618f, 15.921f, 19.843f, 15.952f, 20.122f, 15.989f)
                lineTo(20.122f, 15.989f)
                horizontalLineTo(20.122f)
                curveTo(20.569f, 16.049f, 21.151f, 16.128f, 21.634f, 16.128f)
                curveTo(22.417f, 16.128f, 20.851f, 16.644f, 20.15f, 16.644f)
                curveTo(20.096f, 16.644f, 20.042f, 16.643f, 19.99f, 16.643f)
                curveTo(19.365f, 16.641f, 18.896f, 16.639f, 19.198f, 17.017f)
                curveTo(19.366f, 17.228f, 19.926f, 17.17f, 20.51f, 17.111f)
                curveTo(21.065f, 17.054f, 21.641f, 16.995f, 21.926f, 17.16f)
                curveTo(22.437f, 17.458f, 20.174f, 17.432f, 19.198f, 17.421f)
                horizontalLineTo(19.198f)
                horizontalLineTo(19.198f)
                curveTo(19.059f, 17.419f, 18.945f, 17.418f, 18.87f, 17.418f)
                curveTo(18.27f, 17.418f, 19.471f, 17.641f, 20.504f, 17.641f)
                lineTo(20.634f, 17.641f)
                curveTo(21.557f, 17.64f, 21.776f, 17.64f, 21.776f, 17.944f)
                curveTo(21.776f, 18.211f, 19.765f, 18.142f, 18.926f, 18.113f)
                curveTo(18.767f, 18.107f, 18.649f, 18.103f, 18.596f, 18.103f)
                curveTo(18.435f, 18.103f, 18.342f, 18.201f, 18.246f, 18.301f)
                curveTo(18.143f, 18.409f, 18.035f, 18.521f, 17.837f, 18.521f)
                curveTo(17.674f, 18.521f, 17.598f, 18.416f, 17.528f, 18.321f)
                curveTo(17.434f, 18.193f, 17.352f, 18.081f, 17.087f, 18.264f)
                curveTo(16.627f, 18.583f, 17.548f, 21.8f, 17.548f, 21.8f)
                horizontalLineTo(15.061f)
                verticalLineTo(18.771f)
                curveTo(15.061f, 18.771f, 14.251f, 18.517f, 12.695f, 18.771f)
                close()
                moveTo(15.553f, 4.016f)
                curveTo(15.55f, 4.017f, 15.559f, 4.032f, 15.592f, 4.06f)
                curveTo(15.573f, 4.03f, 15.557f, 4.016f, 15.553f, 4.016f)
                close()
                moveTo(14.688f, 16.024f)
                curveTo(14.295f, 15.876f, 15.291f, 15.868f, 15.752f, 15.868f)
                curveTo(15.9f, 15.868f, 15.953f, 15.868f, 15.956f, 15.881f)
                curveTo(15.958f, 15.888f, 15.945f, 15.899f, 15.924f, 15.916f)
                curveTo(15.867f, 15.963f, 15.752f, 16.058f, 15.752f, 16.248f)
                curveTo(15.752f, 16.532f, 15.378f, 16.35f, 15.025f, 16.177f)
                lineTo(15.025f, 16.177f)
                lineTo(15.025f, 16.177f)
                lineTo(15.025f, 16.177f)
                curveTo(14.905f, 16.119f, 14.788f, 16.061f, 14.688f, 16.024f)
                close()
                moveTo(15.502f, 14.866f)
                curveTo(15.042f, 14.866f, 14.045f, 14.873f, 14.439f, 15.021f)
                curveTo(14.538f, 15.059f, 14.656f, 15.116f, 14.776f, 15.175f)
                lineTo(14.776f, 15.175f)
                lineTo(14.776f, 15.175f)
                lineTo(14.776f, 15.175f)
                curveTo(15.129f, 15.347f, 15.502f, 15.53f, 15.502f, 15.246f)
                curveTo(15.502f, 15.056f, 15.617f, 14.961f, 15.675f, 14.913f)
                curveTo(15.696f, 14.896f, 15.709f, 14.885f, 15.707f, 14.878f)
                curveTo(15.704f, 14.866f, 15.651f, 14.866f, 15.502f, 14.866f)
                close()
                moveTo(14.671f, 14.196f)
                curveTo(14.35f, 14.118f, 15.164f, 14.114f, 15.54f, 14.114f)
                curveTo(15.663f, 14.114f, 15.706f, 14.114f, 15.707f, 14.121f)
                curveTo(15.708f, 14.125f, 15.697f, 14.13f, 15.681f, 14.139f)
                curveTo(15.634f, 14.164f, 15.54f, 14.214f, 15.54f, 14.314f)
                curveTo(15.54f, 14.462f, 15.235f, 14.367f, 14.947f, 14.276f)
                curveTo(14.849f, 14.245f, 14.753f, 14.215f, 14.671f, 14.196f)
                close()
                moveTo(15.481f, 11.026f)
                curveTo(14.959f, 10.867f, 13.83f, 10.526f, 14.253f, 10.736f)
                curveTo(14.36f, 10.79f, 14.484f, 10.859f, 14.611f, 10.93f)
                curveTo(14.984f, 11.139f, 15.379f, 11.36f, 15.422f, 11.217f)
                curveTo(15.451f, 11.122f, 15.596f, 11.114f, 15.669f, 11.11f)
                curveTo(15.693f, 11.108f, 15.71f, 11.108f, 15.71f, 11.104f)
                curveTo(15.712f, 11.097f, 15.653f, 11.079f, 15.481f, 11.026f)
                close()
                moveTo(14.253f, 9.734f)
                curveTo(13.83f, 9.523f, 14.959f, 9.864f, 15.481f, 10.024f)
                curveTo(15.653f, 10.076f, 15.712f, 10.094f, 15.71f, 10.101f)
                curveTo(15.71f, 10.105f, 15.693f, 10.106f, 15.669f, 10.107f)
                curveTo(15.596f, 10.111f, 15.451f, 10.119f, 15.422f, 10.215f)
                curveTo(15.379f, 10.357f, 14.984f, 10.136f, 14.611f, 9.928f)
                lineTo(14.611f, 9.928f)
                curveTo(14.484f, 9.857f, 14.36f, 9.787f, 14.253f, 9.734f)
                close()
                moveTo(15.481f, 8.771f)
                curveTo(14.959f, 8.611f, 13.83f, 8.27f, 14.253f, 8.481f)
                curveTo(14.36f, 8.534f, 14.484f, 8.604f, 14.611f, 8.675f)
                curveTo(14.984f, 8.883f, 15.379f, 9.104f, 15.422f, 8.962f)
                curveTo(15.451f, 8.866f, 15.596f, 8.858f, 15.669f, 8.854f)
                curveTo(15.693f, 8.853f, 15.71f, 8.852f, 15.71f, 8.848f)
                curveTo(15.712f, 8.841f, 15.653f, 8.823f, 15.481f, 8.771f)
                close()
                moveTo(16.609f, 15.618f)
                curveTo(17.07f, 15.618f, 18.066f, 15.625f, 17.673f, 15.773f)
                curveTo(17.573f, 15.811f, 17.455f, 15.868f, 17.336f, 15.927f)
                lineTo(17.336f, 15.927f)
                lineTo(17.336f, 15.927f)
                curveTo(16.983f, 16.099f, 16.609f, 16.281f, 16.609f, 15.998f)
                curveTo(16.609f, 15.808f, 16.494f, 15.712f, 16.436f, 15.665f)
                curveTo(16.416f, 15.648f, 16.403f, 15.637f, 16.404f, 15.63f)
                curveTo(16.408f, 15.618f, 16.461f, 15.618f, 16.609f, 15.618f)
                close()
                moveTo(17.673f, 15.021f)
                curveTo(18.066f, 14.873f, 17.07f, 14.866f, 16.609f, 14.866f)
                curveTo(16.461f, 14.866f, 16.408f, 14.866f, 16.404f, 14.878f)
                curveTo(16.403f, 14.885f, 16.416f, 14.896f, 16.436f, 14.913f)
                curveTo(16.494f, 14.961f, 16.609f, 15.056f, 16.609f, 15.246f)
                curveTo(16.609f, 15.53f, 16.983f, 15.347f, 17.336f, 15.175f)
                lineTo(17.336f, 15.175f)
                lineTo(17.336f, 15.175f)
                lineTo(17.336f, 15.175f)
                curveTo(17.456f, 15.116f, 17.573f, 15.059f, 17.673f, 15.021f)
                close()
                moveTo(18.289f, 13.288f)
                lineTo(18.289f, 13.288f)
                curveTo(18.33f, 13.278f, 18.332f, 13.278f, 18.278f, 13.291f)
                curveTo(18.172f, 13.316f, 17.951f, 13.404f, 17.701f, 13.502f)
                lineTo(17.701f, 13.502f)
                lineTo(17.701f, 13.502f)
                curveTo(17.194f, 13.701f, 16.572f, 13.946f, 16.572f, 13.812f)
                curveTo(16.572f, 13.712f, 16.478f, 13.663f, 16.431f, 13.638f)
                curveTo(16.414f, 13.629f, 16.404f, 13.623f, 16.404f, 13.62f)
                curveTo(16.406f, 13.613f, 16.448f, 13.613f, 16.572f, 13.613f)
                curveTo(16.885f, 13.613f, 18.084f, 13.335f, 18.289f, 13.288f)
                close()
                moveTo(17.859f, 10.235f)
                curveTo(18.281f, 10.025f, 17.152f, 10.366f, 16.631f, 10.525f)
                curveTo(16.458f, 10.578f, 16.4f, 10.595f, 16.401f, 10.603f)
                curveTo(16.402f, 10.606f, 16.418f, 10.607f, 16.442f, 10.609f)
                curveTo(16.515f, 10.613f, 16.66f, 10.62f, 16.689f, 10.716f)
                curveTo(16.733f, 10.858f, 17.127f, 10.638f, 17.5f, 10.429f)
                curveTo(17.627f, 10.358f, 17.751f, 10.288f, 17.859f, 10.235f)
                close()
                moveTo(16.631f, 11.527f)
                curveTo(17.152f, 11.368f, 18.281f, 11.027f, 17.859f, 11.237f)
                curveTo(17.751f, 11.291f, 17.627f, 11.36f, 17.5f, 11.431f)
                curveTo(17.127f, 11.64f, 16.733f, 11.861f, 16.689f, 11.718f)
                curveTo(16.66f, 11.623f, 16.515f, 11.615f, 16.442f, 11.611f)
                curveTo(16.418f, 11.61f, 16.402f, 11.609f, 16.401f, 11.605f)
                curveTo(16.4f, 11.598f, 16.458f, 11.58f, 16.631f, 11.527f)
                close()
                moveTo(17.859f, 9.233f)
                curveTo(18.281f, 9.022f, 17.152f, 9.363f, 16.631f, 9.523f)
                curveTo(16.458f, 9.575f, 16.4f, 9.593f, 16.401f, 9.6f)
                curveTo(16.402f, 9.604f, 16.418f, 9.605f, 16.442f, 9.606f)
                curveTo(16.515f, 9.61f, 16.66f, 9.618f, 16.689f, 9.713f)
                curveTo(16.733f, 9.856f, 17.127f, 9.635f, 17.5f, 9.426f)
                curveTo(17.627f, 9.356f, 17.751f, 9.286f, 17.859f, 9.233f)
                close()
                moveTo(16.288f, 8.646f)
                curveTo(16.647f, 8.537f, 17.426f, 8.303f, 17.142f, 8.471f)
                curveTo(17.07f, 8.513f, 16.987f, 8.57f, 16.902f, 8.628f)
                curveTo(16.653f, 8.799f, 16.39f, 8.98f, 16.346f, 8.837f)
                curveTo(16.317f, 8.742f, 16.212f, 8.722f, 16.16f, 8.712f)
                horizontalLineTo(16.16f)
                curveTo(16.142f, 8.708f, 16.13f, 8.706f, 16.13f, 8.702f)
                curveTo(16.129f, 8.695f, 16.17f, 8.683f, 16.288f, 8.646f)
                close()
                moveTo(16.517f, 12.46f)
                curveTo(16.104f, 12.46f, 16.517f, 12.134f, 16.517f, 12.134f)
                horizontalLineTo(16.73f)
                curveTo(16.803f, 12.134f, 16.868f, 12.104f, 16.954f, 12.064f)
                curveTo(17.118f, 11.989f, 17.356f, 11.879f, 17.867f, 11.879f)
                curveTo(18.646f, 11.879f, 16.93f, 12.46f, 16.517f, 12.46f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun NorfolkIslandPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Large.NorfolkIsland,
            contentDescription = "Norfolk Island Flag"
        )
    }
}
